import { render, staticRenderFns } from "./PkgPlanMenu.vue?vue&type=template&id=609be404&"
import script from "./PkgPlanMenu.vue?vue&type=script&lang=js&"
export * from "./PkgPlanMenu.vue?vue&type=script&lang=js&"
import style0 from "./PkgPlanMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgPlanMenu.vue"
export default component.exports